'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'rv';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = 'M192 32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l136 0c48.6 0 88 39.4 88 88l0 16c0 13.3-10.7 24-24 24l-248 0 0 304-67.3 0c-10.4 36.9-44.4 64-84.7 64-48.6 0-88-39.4-88-88 0-.6 0-1.2 0-1.9-2-2-4-4.2-5.8-6.4L19.9 384.9C7 369.2 0 349.5 0 329.2L0 120C0 71.4 39.4 32 88 32l104 0zM352 208l113.6 0c18.3 0 35.7 7.8 47.8 21.5l46.4 52.2c9.5 10.7 15.1 24.2 16 38.4l.1 0 0 80c0 30.9-21.9 56.6-50.9 62.7-10 37.6-44.3 65.3-85.1 65.3-48.6 0-88-39.4-88-88l0-232zm113.6 64l-49.6 0 0 48 92.3 0-42.7-48zM152 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm328-40a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM128 160c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;